export enum FieldType {
  Text,
  Custom,
  Url,
  Email,
  Tel,
  Img,
  Date,
  Boolean,
  Price,
  Percent,
}

interface TableButton {
  name: string;
  type: string;
  to?: string;
  click?: any;
}

export type TableFieldSearchableValue = string | { order: number, value: string };

export interface TableFieldSearchableValues {
  [key: string]: TableFieldSearchableValue;
  [key: number]: TableFieldSearchableValue;
}

export interface TableSchemaField {
  name: string;
  field: string;
  searchField?: string;
  type?: FieldType; // defaults to Text
  customValue?: (values: any, field: TableSchemaField) => any;
  customRender?: (value: any, field: TableSchemaField, allValues: any) => any;
  mobile?: boolean;
  link?: boolean;
  sortable?: boolean;
  searchable?: boolean;
  defaultSort?: boolean;
  oppositeSortDir?: boolean;
  buttons?: TableButton[];
  searchableValues?: TableFieldSearchableValues;
  defaultSearch?: string | number;
  alias?: string;
  omitSelect?: boolean; //skip selecting particular nested value from object, use when whole parent is fetched
}

export interface TableSchema {
  countPerPage: number;
  fields: TableSchemaField[];
}

export interface TableQuery {
  searchBy?: string;
  searchQuery?: string;
  page?: number;
  sortBy?: string;
  sortDirBack?: 'true' | 'false';
  tenantId?: string;
}

export interface TableResponse<T> {
  countTotal: number;
  items: T[];
}

export interface SortType {
  sort: string;
}
